import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popUpMenuChange,
         selectedCardsGroupsChange,
         standByCardsGroupsChange,
         toggleSwitch,
         setActiveTab } from '../../../actions/index';

import Icon from '@mdi/react';
import { mdiMenuUp } from '@mdi/js';

import { _ } from '../../../functions/translator'
import { handlePosition, handleVisibility } from '../../../functions/popUpMenu/visibiltyFunctions';

const UpButton = (props) => {
    const buttonRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (buttonRef.current) {
                buttonRef.current.classList.add(`button-transition-${props.index}`);
                handleVisibility(buttonRef.current, props.popUpMenu.expanded);
                //handlePosition(buttonRef.current, props.position, props.popUpMenu.close);
            }
        }, 1);
    }, [props.index, props.popUpMenu.expanded, props.position, props.popUpMenu.close]);

    useEffect(() => {
        if (buttonRef.current) {
            handleVisibility(buttonRef.current, props.popUpMenu.expanded);
            //handlePosition(buttonRef.current, props.position, props.popUpMenu.close, props.popUpMenu.opacity);
        }
    }, [props.popUpMenu.expanded, props.position, props.popUpMenu.close, props.popUpMenu.opacity]);
    
    const handleClick = () => {
        if (props.activeTab === 3 && !props.hasSecondActiveTabPermissions) {
            props.setActiveTab(props.activeTab - 2);
        } else if (props.activeTab > 1) {
            props.setActiveTab(props.activeTab - 1);
        }
    };

    let upButtonOpacity = props.activeTab <= 1 ? 0.5 : 1;
    if (props.popUpMenu.close) {
        upButtonOpacity = 0
    }
    return (
        <div style={{opacity: upButtonOpacity}}>
            {props.popUpMenu.show && 
                    <div className="d-flex justify-content-center popup-menu-button card-color" 
                        ref={buttonRef}
                        onClick={handleClick} 
                        style={{ 
                            width:'90px', 
                            backgroundColor:'#ff5300',  
                            position: 'relative', 
                            top: '-80px', 
                            left: '420px',
                            borderBottomRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                        }}>
                        <div className='d-inline-flex'>
                            <Icon path={mdiMenuUp} size='30px' color='white' style={{ margin: 10 }} />
                        </div>
                    </div>
            }
        </div>
    );
}

function mapStateToProps(state) {
    return {
        popUpMenu: state.popUpMenu,
        projectData: state.projectData,
        selectedCardsGroups: state.selectedCardsGroups,
        activeTab: state.activeTab
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        popUpMenuChange: popUpMenuChange,
        selectedCardsGroupsChange: selectedCardsGroupsChange,
        standByCardsGroupsChange: standByCardsGroupsChange,
        toggleSwitch: toggleSwitch,
        setActiveTab: setActiveTab,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(UpButton);
